// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"837238d1","283":"46fc24fd","355":"9fd8c8c7","453":"9332fb52","633":"24427c59"}[chunkId] + ".chunk.js";
};